export default {
	'add-new-album': '',
	album: '',
	'the-album': ''
}